import React, { ReactNode } from 'react';
import classNames from 'classnames';

import FormFieldError from './FormFieldError';
import FormFieldLabel from './FormFieldLabel';
import FormFieldTooltip, { TooltipSource } from './FormFieldTooltip';
import useFormField, { FieldEvent, FieldWidth } from './useFormField';

interface IProps {
  name: string;
  label?: string;
  children: ReactNode;
  tooltip?: TooltipSource;
  description?: string;
  disabled?: boolean;
  width?: FieldWidth;
  onFocus?: FieldEvent<string>;
  onChange?: FieldEvent<string>;
  onBlur?: FieldEvent<string>;
  autoFocus?: boolean;
}

function FormSelectField({
  name,
  label,
  children,
  tooltip,
  description,
  disabled,
  width,
  onFocus,
  onChange,
  onBlur,
  autoFocus = false,
}: IProps) {
  const {
    id,
    fieldProps,
    inputProps,
    required,
    disabled: formDisabled,
  } = useFormField<string>(name, width, { onFocus, onChange, onBlur }, autoFocus);
  const fieldClassName = classNames(fieldProps.className, 'novoFormField--select');

  return (
    <div {...fieldProps} className={fieldClassName}>
      {label && (
        <div className="novoFormField__name">
          <FormFieldLabel for={id} required={required}>
            {label}
          </FormFieldLabel>
          <FormFieldTooltip source={tooltip} />
        </div>
      )}
      {description && <p className="novoFormField__description">{description}</p>}
      <select
        className="novoFormField__input novoFormField__input--select"
        id={id}
        {...inputProps}
        required={required}
        disabled={formDisabled || disabled}
        value={inputProps.value || ''}
      >
        {children}
      </select>
      <FormFieldError name={name} />
    </div>
  );
}

export default FormSelectField;
